<ion-header>
  <ion-toolbar>
    @if (canGoBack()) {
    <ion-button slot="start" fill="clear" (click)="goBack()"
      [attr.aria-label]="'operations.selectRoll.back' | translate">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>
    }
    <ion-title>{{ toolbarTitleKey() | translate }}</ion-title>
    <ion-button slot="end" fill="clear" (click)="dismiss(undefined)" [attr.aria-label]="'common.close' | translate">
      <ion-icon slot="icon-only" name="close"></ion-icon>
    </ion-button>
  </ion-toolbar>
  @if (activeSlideIndex() > 0 && selectedOperation(); as op) {
  <ion-toolbar class="so-progress-toolbar">
    <ion-note class="so-progress-note">
      @if (op.name) {
      {{
      'operations.selectRoll.progressWithOp'
      | translate
      : {
      step: wizardProgress().step,
      total: wizardProgress().total,
      operationName: op.name
      }
      }}
      } @else {
      {{
      'operations.selectRoll.progressStep'
      | translate
      : {
      step: wizardProgress().step,
      total: wizardProgress().total
      }
      }}
      }
    </ion-note>
  </ion-toolbar>
  }
</ion-header>
<ion-content class="so-content">
  <swiper-container #swiper allow-touch-move="false" (swiperslidechange)="onSlideChange($event)">
    <swiper-slide class="so-slide">
      @if (masterSuggestion(); as preset) {
      <div class="so-preset">
        <h2 class="so-preset-heading">{{ preset.name }}</h2>
        <ion-note color="medium" class="so-preset-note">{{
          'operations.selectRoll.suggestedNote' | translate
          }}</ion-note>
      </div>
      } @else if (!hasAnyOperations()) {
      <div class="so-empty">
        <p class="so-empty-title">{{
          'operations.selectRoll.emptyOperations' | translate
          }}</p>
        <ion-note color="medium" class="so-empty-note">{{
          'operations.selectRoll.emptyOperationsHint' | translate
          }}</ion-note>
      </div>
      } @else {
      <ion-list lines="none" class="so-list re-card-list">
        @if (characterOperations().length) {
        <ion-list-header>{{
          'operations.selectRoll.characterOps' | translate
          }}</ion-list-header>
        @for (operation of characterOperations(); let i = $index; track i) {
        <ion-item button [disabled]="operation.disabled" (click)="selectOperation(operation)">
          <ion-label>
            <h2 class="re-list-row-title">{{ operation.name }}</h2>
            @if (operation.disabled) {
            <span class="re-list-row-note">
              {{ 'operations.selectRoll.statsRequired' | translate }}
            </span>
            }
          </ion-label>
        </ion-item>
        }
        } @if (operations().length) {
        <ion-list-header>{{
          'operations.selectRoll.storyOps' | translate
          }}</ion-list-header>
        @for (operation of operations(); let i = $index; track i) {
        <ion-item button [disabled]="operation.disabled" (click)="selectOperation(operation)">
          <ion-label>
            <h2 class="re-list-row-title">{{ operation.name }}</h2>
            @if (operation.disabled) {
            <span class="re-list-row-note">
              {{ 'operations.selectRoll.statsRequired' | translate }}
            </span>
            }
          </ion-label>
        </ion-item>
        }
        }
      </ion-list>
      }
    </swiper-slide>
    @for (slide of slidesSelectStat(); let i = $index; track i) {
    <swiper-slide class="so-slide">
      <re-compile-stat [path]="slide.path" [operation]="slide.fragment" [character]="impersonateChar()!"
        [operationName]="selectedOperation()?.name ?? ''" [statLabel]="statLabelForFragment(slide.fragment)"
        [statHint]="statHintDisplay(slide.fragment)" [active]="activeSlideIndex() === i + 1"
        (compiled)="compiledStat(slide.index, $event)"></re-compile-stat>
    </swiper-slide>
    } @for (slide of slidesInsert(); let i = $index; track i) {
    <swiper-slide class="so-slide">
      <div class="so-insert">
        <div class="so-insert-header">
          <h2 class="so-insert-title">
            {{ insertFieldLabelKey(slide) | translate }}
          </h2>
          @if (slide.insertTotal > 1) {
          <ion-note class="so-insert-progress">
            {{
            'operations.selectRoll.insertProgress'
            | translate
            : {
            current: slide.insertIndex + 1,
            total: slide.insertTotal
            }
            }}
          </ion-note>
          }
          <ion-note class="so-insert-phase">{{
            insertPhaseHintKey(slide) | translate
            }}</ion-note>
          <ion-note class="so-insert-hint">{{ insertHintDisplay(slide) }}</ion-note>
        </div>
        <ion-segment
          class="re-segment re-segment--inline"
          mode="ios"
          [value]="slidesInsertToggle()![i]()"
          (ionChange)="setInsertTab(i, $event.detail.value ?? 'value')"
        >
          <ion-segment-button value="value">{{
            'operations.selectRoll.insertTab.value' | translate
            }}</ion-segment-button>
          <ion-segment-button value="chaos">{{
            'operations.selectRoll.insertTab.chaos' | translate
            }}</ion-segment-button>
        </ion-segment>
        <div class="so-insert-body">
          @if (slidesInsertToggle()![i]!() === 'value') {
          <ion-note class="so-insert-tab-hint">{{
            'operations.selectRoll.insertTab.valueHelp' | translate
            }}</ion-note>
          <ion-list lines="none" class="so-list re-card-list so-insert-list">
            <ion-item>
              <ion-input [name]="'insert' + i" (ionInput)="updateInsertValue(i, $event.detail.value ?? '')"
                [value]="slide.value" type="number" [label]="'operations.selectRoll.insertValue' | translate"
                labelPlacement="stacked" placeholder="0"></ion-input>
            </ion-item>
          </ion-list>
          <ion-button class="so-insert-btn" [disabled]="!insertCanContinue(slide, 'value')" expand="block"
            (click)="compiledInsert(i, slide.value ?? 0)">
            {{ 'common.continue' | translate }}
          </ion-button>
          } @if (slidesInsertToggle()![i]!() === 'chaos') {
          <ion-note class="so-insert-tab-hint">{{
            'operations.selectRoll.insertTab.chaosHelp' | translate
            }}</ion-note>
          <ion-list lines="none" class="so-list re-card-list so-insert-list">
            <ion-item>
              <ion-input [name]="'insertChaos' + i" [disabled]="true" [value]="slide.chaos" type="text"
                [label]="'operations.selectRoll.insertTab.chaos' | translate" labelPlacement="stacked"
                [placeholder]="'operations.selectRoll.selectChaos' | translate"></ion-input>
            </ion-item>
          </ion-list>
          <ion-button class="so-insert-btn so-insert-btn--secondary" fill="outline" expand="block"
            (click)="openSelectChaos(i, insertChaosModalLabel(slide))">
            {{ 'operations.selectRoll.selectDiceFormula' | translate }}
          </ion-button>
          <ion-button class="so-insert-btn" [disabled]="!insertCanContinue(slide, 'chaos')" expand="block"
            (click)="compiledInsertChaos(i, slide.chaos ?? '')">
            {{ 'common.continue' | translate }}
          </ion-button>
          }
        </div>
      </div>
    </swiper-slide>
    }
    <swiper-slide class="so-slide so-slide--footer">
      <div class="so-complete">
        <div class="so-complete-summary">
          @if (finalizeSummary(); as fin) {
          <p class="so-complete-kicker">{{
            'operations.selectRoll.readyToRoll' | translate
            }}</p>
          <h2 class="so-complete-title">{{ fin.operationName }}</h2>
          @if (fin.characterName) {
          <p class="so-complete-meta">
            <ion-icon name="person-circle-outline" aria-hidden="true"></ion-icon>
            <span>{{ fin.characterName }}</span>
          </p>
          }
          @if (fin.choiceRows.length) {
          <ul class="so-complete-choices" [attr.aria-label]="'operations.selectRoll.summaryChoices' | translate">
            @for (choice of fin.choiceRows; track $index) {
            <li class="so-complete-choice">
              @if (choice.label) {
              <span class="so-complete-choice-label">{{ choice.label }}</span>
              }
              <span class="so-complete-choice-value">{{ choice.value }}</span>
            </li>
            }
          </ul>
          }
          } @else {
          <p class="so-complete-kicker">{{
            'operations.selectRoll.ready' | translate
            }}</p>
          <h2 class="so-complete-title">{{
            'operations.selectRoll.confirm' | translate
            }}</h2>
          }
        </div>
        <ion-note color="medium" class="so-complete-hint">
          @if (masterSuggestion()) {
          {{ 'operations.selectRoll.sendRollHint' | translate }}
          } @else {
          {{ 'operations.selectRoll.addToMessageHint' | translate }}
          }
        </ion-note>
        <ion-button class="so-complete-btn" expand="block" size="large" (click)="complete()">
          <ion-icon slot="start" name="checkmark-circle-outline" aria-hidden="true"></ion-icon>
          @if (masterSuggestion()) {
          {{ 'operations.selectRoll.sendRoll' | translate }}
          } @else {
          {{ 'operations.selectRoll.addToMessage' | translate }}
          }
        </ion-button>
      </div>
    </swiper-slide>
  </swiper-container>
</ion-content>